// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__mdvox","textRed":"styles_textRed__WEuJH","itemImage":"styles_itemImage__iYZPn","textItemTitle":"styles_textItemTitle__EucqI"};